import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgImage({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 3a3 3 0 013 3v12a3 3 0 01-3 3H6a3 3 0 01-3-3V6a3 3 0 013-3h12zM7.293 13.121l-2.294 2.294V18a1 1 0 001 1h12a1 1 0 001-1l.003-2.584-.295-.295a1 1 0 00-1.32-.083l-.094.083-1.172 1.172a3 3 0 01-4.098.135l-.144-.135-3.172-3.172a1 1 0 00-1.414 0zM18 5.001H6a1 1 0 00-1 1v6.585l.879-.879a3 3 0 014.098-.135l.144.135 3.172 3.172a1 1 0 001.32.083l.094-.083 1.172-1.172A3 3 0 0119 13L19 6a1 1 0 00-1-1zM15 7a2 2 0 110 4 2 2 0 010-4z"
        fill={color}
      />
    </svg>
  )
}

export default SvgImage
